module.exports = __webpack_public_path__ + "img/ganamos.82e8fed2.png";